// extracted by mini-css-extract-plugin
module.exports = {"Kicker":"Kicker_Kicker__GGP6E","Kicker_kickerFirst":"Kicker_Kicker_kickerFirst__Pkiy9","Kicker_kickerSecond":"Kicker_Kicker_kickerSecond__6of27"};